import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { PauseCircleOutlined, PlayCircleOutlined, AudioMutedOutlined, AudioOutlined, PartitionOutlined } from '@ant-design/icons';
import { useNicService } from 'stores/nic/useNicService';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
export var useCallActionsConfig = function (callIndex) {
    var calls = useCallStore(selectCalls);
    var isOnHold = useCallStore(function (state) { var _a, _b; return (_b = (_a = state.calls[callIndex]) === null || _a === void 0 ? void 0 : _a.isOnHold) !== null && _b !== void 0 ? _b : false; });
    var isMuted = useCallStore(function (state) { var _a, _b; return (_b = (_a = state.calls[callIndex]) === null || _a === void 0 ? void 0 : _a.isMuted) !== null && _b !== void 0 ? _b : false; });
    var showAdditionalDirectory = useCallStore(function (state) { return state.showAdditionalDirectory; });
    var _a = useNicService(), holdResumeCall = _a.holdResumeCall, muteUnmuteCall = _a.muteUnmuteCall, transferCall = _a.transferCall;
    // Check if this tab owns the active call - reactive to BroadcastChannel changes
    var _b = useState(function () {
        var tabId = sessionStorage.getItem('tabId');
        var activeTabId = localStorage.getItem('activeCallTabId');
        return tabId === activeTabId;
    }), isOwningTab = _b[0], setIsOwningTab = _b[1];
    useEffect(function () {
        var checkOwnership = function () {
            var tabId = sessionStorage.getItem('tabId');
            var activeTabId = localStorage.getItem('activeCallTabId');
            setIsOwningTab(tabId === activeTabId);
        };
        // Check ownership when calls change (new call, call accepted, etc.)
        checkOwnership();
        // Use BroadcastChannel for cross-tab ownership notifications
        var ownershipChannel = new BroadcastChannel('nic-call-ownership');
        ownershipChannel.onmessage = function (event) {
            if (event.data.type === 'ownership-changed') {
                checkOwnership();
            }
        };
        return function () {
            ownershipChannel.close();
        };
    }, [calls]);
    var activeCalls = calls.filter(function (c) { return c.call !== null; });
    var handleTransfer = function () {
        if (activeCalls.length === 1) {
            // Toggle the directory
            useCallStore.getState().setShowAdditionalDirectory(!showAdditionalDirectory);
        }
        else if (activeCalls.length === 2) {
            transferCall();
        }
    };
    var callActionsConfig = {
        hold: {
            icon: isOnHold ? (_jsx(PlayCircleOutlined, { style: { fontSize: 20 } })) : (_jsx(PauseCircleOutlined, { style: { fontSize: 20 } })),
            getText: function () { return (isOnHold ? 'Resume' : 'Hold'); },
            onClick: function () { return holdResumeCall(callIndex); }
        },
        mute: {
            icon: isMuted ? (_jsx(AudioOutlined, { style: { fontSize: 20 } })) : (_jsx(AudioMutedOutlined, { style: { fontSize: 20 } })),
            getText: function () { return (isMuted ? 'Unmute' : 'Mute'); },
            onClick: function () { return muteUnmuteCall(callIndex); },
            disabled: !isOwningTab,
            disabledTooltip: 'Audio controls are only available in the active call tab'
        },
        transfer: {
            icon: _jsx(PartitionOutlined, { style: { fontSize: 20 } }),
            getText: function () { return 'Transfer'; },
            onClick: handleTransfer
        }
        // record: {
        //   icon: <PhoneOutlined style={{ fontSize: 20 }} />,
        //   getText: cfg => cfg.controlText,
        //   onClick: () => console.log('record clicked')
        // },
        // mask: {
        //   icon: <PhoneOutlined style={{ fontSize: 20 }} />,
        //   getText: cfg => cfg.controlText,
        //   onClick: () => console.log('mask clicked')
        // },
        // end: {
        //   icon: <PhoneOutlined rotate={225} />,
        //   getText: cfg => cfg.controlText,
        //   onClick: rejectIncomingCall
        // }
    };
    return callActionsConfig;
};
